
import { Component, Prop, Vue } from "vue-property-decorator";
import { BvTableFieldArray } from "bootstrap-vue";
import { i18n } from "@/i18n";
import IconTrash from "@/components/common/icon/IconTrash.vue";
import IconEdit from "@/components/common/icon/IconEdit.vue";
import AddEditLimitModal from "@/components/limits/AddEditLimitModal.vue";
import { Getter } from "vuex-class";
import { IPageResponse } from "@/services";
import { ICurrency, ILimit } from "@/entities";

@Component({
  name: "limits-table",
  components: {
    IconEdit,
    AddEditLimitModal,
    IconTrash,
  },
})
export default class LimitsTable extends Vue {
  @Getter("getCurrenciesPage") currenciesPage?: IPageResponse<ICurrency>;
  @Prop({ required: false, default: null }) limitList!: ILimit[];
  private limitSelected: ILimit | null = null;
  public collapsed = true;

  constructor() {
    super();
  }

  get fields(): BvTableFieldArray {
    return [
      {
        key: "actions-left",
        label: "",
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-first align-middle",
      },
      {
        key: "currency.code",
        label: i18n.t("label.currency") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
      },
      {
        key: "amount",
        label: i18n.t("column.amount") as string,
        sortable: false,
        thClass: "table-header",
        tdClass: "table-cell-middle align-middle",
        formatter: (value: number, _key: string, item: ILimit) => {
          return this.$options.filters?.currency(value, item.currency?.symbol);
        },
      },
      {
        key: "actions-right",
        label: "",
        sortable: false,
        thClass: "table-header py-0",
        tdClass: "table-cell-last align-middle",
      },
    ];
  }

  removeLimit(index: number): void {
    this.limitList.splice(index, 1);
  }

  openNewLimitModal(): void {
    this.limitSelected = null;
    this.$nextTick(() => this.$bvModal.show("addEditLimitModal"));
  }
  editLimit(limit: ILimit): void {
    this.limitSelected = limit;
    this.$nextTick(() => this.$bvModal.show("addEditLimitModal"));
  }
}
